import React from 'react';
import useTranslations from '../useTranslations';
// import SocialLinks from '../SocialLinks';
import Copyright from '../Copyright';

import * as S from './styled';
import DevelopedBy from '../DevelopedBy';

const Footer = () => {
  const {
    aboutProject,
    seeMorePWA,
    maintainedBy,
    contributeMessage,
  } = useTranslations();

  return (
    <S.FooterWrapper>
      <S.FooterContainer>
        <Copyright>
          <span>Essentia Consultancy</span>
        </Copyright>
        <DevelopedBy style={{'padding': 'var(--space-sm)'}} href="//juliahop.github.io" />
      </S.FooterContainer>
    </S.FooterWrapper>
  );
};

export default Footer;

{/* <SocialLinks style={{color: 'var(--gray-light)'}}/> */}


